export default {
  'tasks.title': 'Tasks',
  'tasks.filter.type': 'Type',
  'tasks.filter.processGroup': 'Process Group',
  'tasks.filter.type.task': 'Task',
  'tasks.filter.type.completeInformation': 'Complete Information',
  'tasks.filter.type.approval': 'Approval',
  'tasks.filter.type.executeTask': 'Execute Task',
  'tasks.filter.type.digitalSignature': 'Digital Signature',
  'tasks.filter.applicantUser': 'Applicant',
  'tasks.filter.process': 'Process',
  'tasks.filter.importance': 'Importance',
  'tasks.filter.overdue': 'Overdue Date',
  'tasks.filter.planned': 'Planned Date',
  'tasks.filter.reminder': 'Reminder Date',

  'tasks.filter.type.none': 'None',
  'tasks.filter.type.low': 'Low',
  'tasks.filter.type.medium': 'Medium',
  'tasks.filter.type.high': 'High',
  'tasks.filter.type.urgent': 'Urgent',
  'tasks.filter.type.critical': 'Critical',

  'tasks.importance.type0': 'None',
  'tasks.importance.type1': 'Low',
  'tasks.importance.type2': 'Medium',
  'tasks.importance.type3': 'High',
  'tasks.importance.type4': 'Urgent',
  'tasks.importance.type5': 'Critical',

  'tasks.description.none': 'No priority',
  'tasks.description.low': 'Indicates low priority',
  'tasks.description.medium': 'Medium importance. Not urgent but requires attention.',
  'tasks.description.high': 'High priority, needs to be resolved soon.',
  'tasks.description.urgent': 'Requires immediate action. Time is a factor.',
  'tasks.description.critical': 'High risk situation, immediate action required.',

  'tasks.text.overdueDateTime': 'Overdue Date',
  'tasks.text.plannedDateTime': 'Planned Date',
  'tasks.text.reminderDateTime': 'Reminder Date',

  'tasks.list.created': 'The list "{name}" was created successfully',
  'tasks.list.updated': 'The list "{name}" was updated successfully',
  'tasks.list.removed': 'The list "{name}" was deleted successfully',
  'tasks.task.created': 'The task "{name}" was created successfully',
  'tasks.task.updated': 'The task "{name}" was updated successfully',
  'tasks.task.removed': 'The task "{name}" was deleted successfully',
  'tasks.task.toMayDay': 'The task "{name}" was assigned to My Day successfully',

  'task.status.complete': 'Complete Information',
  'task.status.approved': 'Approval',
  'task.status.execution': 'Execute Task',
  'task.status.signature': 'Digital Signature',
  'task.detail.applicant': 'Applicant',
  'task.detail.comment': 'Add Comment',
  'task.detail.observation': 'Enter observation',
  'task.detail.overdue': 'Overdue',
  'tasks.detail.notes': 'Notes',

  'tasks.empty.title': 'You do not have any task assigned',
  'tasks.empty.subtitle': 'Select a suggested task or create one',
  'tasks.move.title': 'Move Task',

  'tasks.text.listName': 'List Name',
  'tasks.text.createList': 'Create List',
  'tasks.text.editList': 'Edit List',
  'tasks.text.customList': 'Custom List',
  'tasks.text.taskTypes': 'Task Types',
  'tasks.text.title': 'Title',
  'tasks.text.favorite': 'Favorite',
  'tasks.text.newTask': 'Add New Task',
  'tasks.text.assignTo': 'Assign to',

  'tasks.type.task': 'Task',
  'tasks.type.tasks': 'Tasks',
  'tasks.type.my-day': 'My Day',
  'tasks.type.favorites': 'Favorites',
  'tasks.type.planned': 'Planned',
  'tasks.type.overdue': 'Overdue',
  'tasks.type.completed': 'Completed',
  'tasks.type.custom': 'Custom',

  'tasks.type.basic': 'Basic',
  'tasks.type.filter-by-process': 'Filter by Process',
  'tasks.type.filter-by-task-importances': 'Filter by Task Importances',
  'tasks.type.link-custom-list': 'Link Custom List',
  'tasks.type.advanced-filter': 'Advanced Filter',
  'tasks.type.filter-by-task-type': 'Filter by Task Type',

  'tasks.status.pending': 'Pending',
  'tasks.status.in-progress': 'In Progress',
  'tasks.status.blocked': 'Blocked',
  'tasks.status.on-hold': 'On Hold',
  'tasks.status.completed': 'Completed',
  'tasks.status.canceled': 'Canceled',
  'tasks.status.failed': 'Failed',

  'tasks.status.type1': 'Pending',
  'tasks.status.type2': 'In Progress',
  'tasks.status.type3': 'Blocked',
  'tasks.status.type4': 'On Hold',
  'tasks.status.type5': 'Completed',
  'tasks.status.type6': 'Canceled',
  'tasks.status.type7': 'Failed',
};
